import React from 'react';
import '../styles/components/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 SAP Movers. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
